import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ConfigService } from '../../services/config.service';

@Injectable({
  providedIn: 'root',
})
export class ServiceCalendarGuard implements CanActivate {
  private readonly configService = inject(ConfigService);
  private readonly router = inject(Router);

  canActivate(): boolean | UrlTree {
    return this.configService.enableServiceCalendar
      ? true
      : this.router.parseUrl('/calendar');
  }
}
